module.exports = __webpack_public_path__ + "static/media/Archivo_000.e322fd78.jpeg";